import { Grid, List, Typography } from "@mui/material"
import React from "react"
import { Option } from "./Option"
import { useTranslation } from "react-i18next"

export const Question = (props) => {
  const { item, index, totalQuestions } = props
  const { t } = useTranslation()

  return (
    <React.Fragment>
      <Typography variant="caption">
        {t("global.question", "Question")} {index}/{totalQuestions}
      </Typography>
      <Grid container justifyContent="space-between" alignItems="center">
        <Typography variant="h5">{item.question}</Typography>{" "}
      </Grid>

      <List dense>
        {item.options.map((item, key) => {
          return <Option item={item} key={key} />
        })}
      </List>
    </React.Fragment>
  )
}
